import classNames from "classnames";

import styles from "./ThinkingIndicator.module.css";

interface ThinkingIndicatorProps {
  size?: "medium" | "small";
  /** Text shown after the dots, naming what the wait is for. */
  label?: string;
}

export const ThinkingIndicator = ({
  size = "medium",
  label,
}: ThinkingIndicatorProps) => {
  const containerClass = classNames(styles.container, {
    [styles["container-small"]]: size === "small",
  });
  const dotClass = styles.dot;

  return (
    <div className={containerClass}>
      <div className={dotClass} />
      <div className={dotClass} />
      <div className={dotClass} />
      <ThinkingLabel label={label} />
    </div>
  );
};

const ThinkingLabel = ({ label }: { label?: string }) => {
  if (!label) {
    return null;
  }
  return <span className={styles.label}>{label}</span>;
};
